import * as React from 'react';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';

const FedexAttribution: React.FunctionComponent = () => {
  // TODO: Pass in feature name
  const { smalltextDefaultNone } = useTheme();

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={smalltextDefaultNone}>Service provided by</div>
      <img
        style={{
          width: '2.9375rem',
          height: '0.8125rem',
          marginLeft: '0.5rem',
        }}
        src="https://assets.narvar.com/carriers/fedex.png"
        alt="FedEx logo"
      />
    </div>
  );
};

export default withThemeProvider(FedexAttribution, {
  themeTokens: ['smalltextDefaultNone'],
});
